import { PasswordCondition } from './PasswordHelper.types';

export const defaultPasswordConditions: PasswordCondition[] = [
  {
    message: 'password.custom_validation.between_8_and_20_chars',
    regex: /^.{8,20}$/,
  },
  {
    message: 'password.custom_validation.include_upper_case',
    regex: /[A-Z]/,
  },
  {
    message: 'password.custom_validation.include_lower_case',
    regex: /[a-z]/,
  },
  {
    message: 'password.custom_validation.contains_numbers',
    regex: /\d/,
  },
  {
    message: 'password.custom_validation.contains_special_chars',
    regex: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/,
  },
];
